

export const initialState = {
    price: [0, 2000],
    availability: "All",
    size: [],
    category: "All",
    gender: [], // çoklu seçim için dizi
    filtered: [],
    sortingOption: "Sort by (Default)",
    sorted: [],
    currentPage: 1,
    itemPerPage: 16,
};

export function reducer(state, action) {
    switch (action.type) {
        case "SET_PRICE":
            return { ...state, price: action.payload };

        // case "SET_SIZE":
        //     return { ...state, size: action.payload };
        case "TOGGLE_SIZE":
            const hasSize = state.size.includes(action.payload);
            return {
                ...state,
                size: hasSize
                    ? state.size.filter((s) => s !== action.payload)
                    : [...state.size, action.payload],
            };



        case "SET_AVAILABILITY":
            return {
                ...state,
                availability:
                    state.availability === action.payload ? "All" : action.payload,
            };


        case "SET_FILTERED":
            return { ...state, filtered: [...action.payload] };

        case "SET_SORTING_OPTION":
            return { ...state, sortingOption: action.payload };

        case "SET_SORTED":
            return { ...state, sorted: [...action.payload] };

        case "SET_CURRENT_PAGE":
            return { ...state, currentPage: action.payload };

        case "SET_ITEM_PER_PAGE":
            return { ...state, itemPerPage: action.payload };

        case "SET_CATEGORY":
            return { ...state, category: action.payload };

        // ✅ YENİ EKLEDİK → çoklu gender toggle
        case "TOGGLE_GENDER":
            const exists = state.gender.includes(action.payload);
            return {
                ...state,
                gender: exists
                    ? state.gender.filter((g) => g !== action.payload)
                    : [...state.gender, action.payload],
            };

        case "CLEAR_FILTER":
            return {
                ...state,
                price: [0, 2000],
                availability: "All",
                size: [],
                category: "All",
                gender: [], // "All" değil artık
            };

        default:
            return state;
    }
}
